import React from "react";

interface ScoreData {
  label: string;
  value: number;
}

interface MatchScoreDistributionProps {
  title?: string;
  data: ScoreData[];
  height?: string;
  colors?: [];
  className?: string;
}

const defaultColors = [
  "bg-red-500",
  "bg-red-400",
  "bg-orange-400",
  "bg-orange-300",
  "bg-yellow-400",
  "bg-yellow-300",
  "bg-green-300",
  "bg-green-400",
  "bg-green-500",
  "bg-green-600",
];

export const DistributionBarGraph: React.FC<MatchScoreDistributionProps> = ({
  title = "Match Score Distribution",
  data,
  height = "h-48",
  colors = defaultColors,
  className = "",
}) => {
  const sortedData = [...data];
  const maxCount = Math.max(...data.map((item) => item.value));

  return (
    <div
      className={`bg-white rounded-lg border border-gray-100 p-4 ${className}`}
    >
      <div className="flex items-center mb-3">
        <h3 className="text-[14px] font-medium text-gray-700">{title}</h3>
      </div>

      <div
        className={`${height} bg-gray-50/50 rounded-lg px-2 flex items-end pb-6`}
      >
        <div className="grid grid-cols-10 gap-1 w-full h-32">
          {sortedData.map(({ label, value }, index) => {
            const heightPercent = maxCount > 0 ? (value / maxCount) * 100 : 0;

            return (
              <div key={label} className="flex flex-col items-center h-full">
                <div className="flex-grow w-full flex items-end">
                  <div
                    className={`w-full ${colors[index % colors.length] || "bg-gray-400"} rounded-t-sm transition-all duration-300`}
                    style={{ height: `${Math.max(heightPercent, 2)}%` }}
                  />
                </div>
                <span className="text-xs text-gray-600 mt-1">{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
